import GATSBY_COMPILED_MDX from "/vercel/path0/content/guides/how-to-trigger-modbus-write-from-input-control.mdx";
import React from 'react';
import {graphql, Link} from 'gatsby';
import {titleCase} from 'title-case';
import {css} from '@emotion/react';
import {Button} from 'react-bulma-components';
import {MDXProvider} from '@mdx-js/react';
import SEO from '../components/SEO';
import Aside from '../components/table-of-contents/guide';
import WasThisHelpful from '../components/WasThisHelpful';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import * as Styles from '../styles/doc.module.scss';
import * as ContentStyle from '../styles/content.module.scss';
const NavButton = ({text, link}) => {
  return React.createElement(Link, {
    to: link || '/'
  }, React.createElement(Button, {
    className: `${Styles.ButtonPersonalization} ${link ? 'visible' : 'hidden'}`
  }, text));
};
function GuideTemplate({data, location, children}) {
  const post = data.mdx;
  const {prev, next, description, title, category} = post.frontmatter;
  const {slug} = post.fields;
  const MetaData = () => {
    return React.createElement(React.Fragment, null, React.createElement("h1", null, titleCase(title)), React.createElement("div", {
      css: css`
            display: flex;
            text-transform: uppercase;
            margin-top: 2px;
            margin-bottom: 10px;
            font-family: 'Alternate Gothic', Helvetica, sans-serif;
          `
    }, React.createElement("span", {
      css: css`
              color: #cfd1d5 !important;
            `
    })));
  };
  return React.createElement(React.Fragment, null, React.createElement(Nav, {
    location: location,
    post: post
  }), React.createElement("div", {
    style: {
      padding: '40px'
    },
    className: Styles.DocWrapper
  }, React.createElement("div", {
    className: ContentStyle.SectionWrapper
  }, React.createElement("div", {
    className: ContentStyle.Section,
    style: {
      maxWidth: '900px'
    },
    role: "main"
  }, React.createElement(SEO, {
    description: description,
    title: titleCase(title),
    slug: slug
  }), React.createElement("main", {
    id: "main",
    "data-category": category,
    "data-slug": slug
  }, React.createElement(MetaData), React.createElement(MDXProvider, null, children), React.createElement("div", {
    className: Styles.ButtonsPrevNext
  }, React.createElement(NavButton, {
    link: prev,
    text: "Prev"
  }), React.createElement(NavButton, {
    link: next,
    text: "Next"
  }))), React.createElement(WasThisHelpful), React.createElement(Footer))), React.createElement(Aside, {
    post: post
  })));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(GuideTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query GuideTemplate($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      id
      body
      tableOfContents
      frontmatter {
        title
        description
        category
        date
        prev
        next
        resources {
          name
          url
        }
      }
      fields {
        slug
      }
      internal {
        contentFilePath
      }
    }
  }
`;
